import throttle from 'lodash/throttle';
import { useEffect } from 'react';
/**
 * Call the specified scroll handler using the supplied throttle timing.
 * @param handler
 */
export function useScrollHandler(handler, passive = false, wait = 100) {
    useEffect(() => {
        handler();
        window.addEventListener('scroll', throttle(handler, wait), { passive });
    }, []);
}
